// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggleButton_xmE5L {
  font: bold 16px/26px var( --vf-Inter );
  color: var( --color-brand500 );
  border: 0px solid currentColor;
  padding: var( --size-padMedium );
  outline: none;
  display: flex;
  flex-wrap: nowrap;
  transition: background-color 0.2s,color 0.2s,transform 0.2s;
  align-items: center;
  border-radius: 4px;
  flex-direction: row;
  justify-content: center;
  background-color: transparent;
}
.toggleButton_xmE5L > *+* {
  margin: 0 0 0 var( --size-padMedium );
}
.toggleButton_xmE5L[data-value=true] {
  color: var( --color-brand500 );
  border-radius: 4px;
  background-color: var( --color-brand100 );
}
.toggleButton_xmE5L:focus {
  color: var( --color-brand500 );
}
.toggleButton_xmE5L:focus[data-value=true] {
  color: var( --color-brand500 );
}
.toggleButton_xmE5L:hover {
  color: var( --color-brand500 );
  background-color: var( --color-brand050 );
}
.toggleButton_xmE5L:active {
  color: var( --color-brand700 );
}
.toggleButton_xmE5L[disabled] {
  color: var( --color-base300 );
}
.toggleButton_xmE5L[disabled][data-value=true] {
  background-color: var( --color-base050 );
}
.toggleButton_xmE5L.toggleButton-iconBig_fytRJ {
  width: 40px;
  border: 1px solid var( --color-base200 );
  height: 40px;
  padding: 0px;
  font-size: 24px;
}
.toggleButton_xmE5L.toggleButton-iconBig_fytRJ[data-value=true] {
  border-top-color: var( --color-brand500 );
  border-left-color: var( --color-brand500 );
  border-right-color: var( --color-brand500 );
  border-bottom-color: var( --color-brand500 );
}
.toggleButton_xmE5L.toggleButton-iconBig_fytRJ[disabled][data-value=true] {
  border-top-color: var( --color-base200 );
  border-left-color: var( --color-base200 );
  border-right-color: var( --color-base200 );
  border-bottom-color: var( --color-base200 );
}
.toggleButton_xmE5L.toggleButton-iconBig_fytRJ.toggleButton-iconMedium_hsFcg {
  width: 32px;
  height: 32px;
  font-size: 16px;
}
.toggleButton_xmE5L.toggleButton-iconBig_fytRJ.toggleButton-iconMedium_hsFcg.toggleButton-iconSmall_fPjTE {
  width: 24px;
  height: 24px;
  font-size: 16px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.toggleButton_xmE5L.toggleButton-iconBig_fytRJ.toggleButton-iconMedium_hsFcg.toggleButton-iconSmall_fPjTE[data-value=true] {
  border: 1px solid var( --color-brand500 );
}
.toggleButton_xmE5L.toggleButton-actions_sO2d8 {
  font: 600 12px/18px var( --vf-Inter );
  color: var( --color-base700 );
  border: 1px solid var( --color-base100 );
  height: 32px;
  padding: 0px var( --size-padMedium );
  display: flex;
  margin-left: var( --size-medium );
  flex-direction: row-reverse;
  justify-content: flex-start;
  background-color: var( --color-base100 );
}
.toggleButton_xmE5L.toggleButton-actions_sO2d8[data-value=true] {
  color: var( --color-brand500 );
  border: 1px solid var( --color-brand500 );
  background-color: var( --color-brand100 );
}
.toggleButton_xmE5L.toggleButton-actions_sO2d8:hover {
  color: var( --color-brand500 );
  background-color: var( --color-brand050 );
}
.toggleButton_xmE5L.toggleButton-actions_sO2d8[disabled][data-value=true] {
  color: var( --color-base700 );
  background-color: var( --color-base100 );
  border-top-color: var( --color-base700 );
  border-left-color: var( --color-base700 );
  border-right-color: var( --color-base700 );
  border-bottom-color: var( --color-base700 );
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq {
  font: 700 15px/24px var( --vf-Inter );
  color: var( --color-base200 );
  height: 48px;
  display: flex;
  margin-top: var( --size-padMedium );
  margin-left: var( --size-padLarge );
  align-items: center;
  padding-left: var( --size-padLarge );
  margin-right: var( --size-padXLarge );
  border-radius: 12px;
  padding-right: var( --size-padLarge );
  flex-direction: row;
  justify-content: flex-start;
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq[data-value=true] {
  color: var( --color-white );
  background-color: var( --color-brand500 );
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq:hover {
  background-color: rgba(38, 26, 203, 0.5);
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq.toggleButton-navSubItem_eOZym[data-value=true] {
  border-radius: 100px;
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq.toggleButton-navCollapsed_mPKIc {
  width: 40px;
  height: 40px;
  padding: 0px;
  display: flex;
  margin-left: auto;
  align-items: center;
  margin-right: auto;
  flex-direction: row;
  justify-content: center;
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq.toggleButton-navSecondary_RCyln {
  font: bold 15px/24px var( --vf-Inter );
  color: var( --color-base500 );
  min-height: 0px;
  border-radius: 100px;
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq.toggleButton-navSecondary_RCyln[data-value=true] {
  color: var( --color-brand500 );
  background-color: var( --color-brand100 );
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq.toggleButton-navSecondary_RCyln:hover {
  color: var( --color-brand500 );
  background-color: var( --color-brand050 );
}
.toggleButton_xmE5L.toggleButton-mobile_LwOqO {
  border-radius: 100%;
}
.toggleButton_xmE5L.toggleButton-mobile_LwOqO[data-value=true] {
  color: var( --color-white );
  background-color: var( --color-brand500 );
}
.toggleButton_xmE5L.toggleButton-mobileDateRange_Celzo {
  color: var( --color-base500 );
  width: 100%;
  height: 40px;
  text-align: center;
  border-radius: 100%;
  background-color: var( --color-base100 );
}
.toggleButton_xmE5L.toggleButton-mobileDateRange_Celzo[data-value=true] {
  color: var( --color-brand500 );
  background-color: var( --color-brand100 );
}
.toggleButton_xmE5L.toggleButton-mobileDateRange_Celzo:active {
  color: var( --color-brand500 );
  background-color: var( --color-brand050 );
}
.toggleButton_xmE5L.toggleButton-mobileDateRange_Celzo:active[data-value=true] {
  background-color: var( --color-brand100 );
}
.toggleButton_xmE5L.toggleButton-nav_NuPbq > *+* {
  margin: 0 0 0 var( --size-padLarge );
}
.toggleButton_xmE5L.toggleButton-actions_sO2d8 > *+* {
  margin: 0 var( --size-padSmall ) 0 0;
}`, "",{"version":3,"sources":["webpack://./src/theme/ToggleButton.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,2DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,wCAAwC;EACxC,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,yCAAyC;AAC3C;AACA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".toggleButton {\n  font: bold 16px/26px var( --vf-Inter );\n  color: var( --color-brand500 );\n  border: 0px solid currentColor;\n  padding: var( --size-padMedium );\n  outline: none;\n  display: flex;\n  flex-wrap: nowrap;\n  transition: background-color 0.2s,color 0.2s,transform 0.2s;\n  align-items: center;\n  border-radius: 4px;\n  flex-direction: row;\n  justify-content: center;\n  background-color: transparent;\n}\n.toggleButton > *+* {\n  margin: 0 0 0 var( --size-padMedium );\n}\n.toggleButton[data-value=true] {\n  color: var( --color-brand500 );\n  border-radius: 4px;\n  background-color: var( --color-brand100 );\n}\n.toggleButton:focus {\n  color: var( --color-brand500 );\n}\n.toggleButton:focus[data-value=true] {\n  color: var( --color-brand500 );\n}\n.toggleButton:hover {\n  color: var( --color-brand500 );\n  background-color: var( --color-brand050 );\n}\n.toggleButton:active {\n  color: var( --color-brand700 );\n}\n.toggleButton[disabled] {\n  color: var( --color-base300 );\n}\n.toggleButton[disabled][data-value=true] {\n  background-color: var( --color-base050 );\n}\n.toggleButton.toggleButton-iconBig {\n  width: 40px;\n  border: 1px solid var( --color-base200 );\n  height: 40px;\n  padding: 0px;\n  font-size: 24px;\n}\n.toggleButton.toggleButton-iconBig[data-value=true] {\n  border-top-color: var( --color-brand500 );\n  border-left-color: var( --color-brand500 );\n  border-right-color: var( --color-brand500 );\n  border-bottom-color: var( --color-brand500 );\n}\n.toggleButton.toggleButton-iconBig[disabled][data-value=true] {\n  border-top-color: var( --color-base200 );\n  border-left-color: var( --color-base200 );\n  border-right-color: var( --color-base200 );\n  border-bottom-color: var( --color-base200 );\n}\n.toggleButton.toggleButton-iconBig.toggleButton-iconMedium {\n  width: 32px;\n  height: 32px;\n  font-size: 16px;\n}\n.toggleButton.toggleButton-iconBig.toggleButton-iconMedium.toggleButton-iconSmall {\n  width: 24px;\n  height: 24px;\n  font-size: 16px;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.toggleButton.toggleButton-iconBig.toggleButton-iconMedium.toggleButton-iconSmall[data-value=true] {\n  border: 1px solid var( --color-brand500 );\n}\n.toggleButton.toggleButton-actions {\n  font: 600 12px/18px var( --vf-Inter );\n  color: var( --color-base700 );\n  border: 1px solid var( --color-base100 );\n  height: 32px;\n  padding: 0px var( --size-padMedium );\n  display: flex;\n  margin-left: var( --size-medium );\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  background-color: var( --color-base100 );\n}\n.toggleButton.toggleButton-actions[data-value=true] {\n  color: var( --color-brand500 );\n  border: 1px solid var( --color-brand500 );\n  background-color: var( --color-brand100 );\n}\n.toggleButton.toggleButton-actions:hover {\n  color: var( --color-brand500 );\n  background-color: var( --color-brand050 );\n}\n.toggleButton.toggleButton-actions[disabled][data-value=true] {\n  color: var( --color-base700 );\n  background-color: var( --color-base100 );\n  border-top-color: var( --color-base700 );\n  border-left-color: var( --color-base700 );\n  border-right-color: var( --color-base700 );\n  border-bottom-color: var( --color-base700 );\n}\n.toggleButton.toggleButton-nav {\n  font: 700 15px/24px var( --vf-Inter );\n  color: var( --color-base200 );\n  height: 48px;\n  display: flex;\n  margin-top: var( --size-padMedium );\n  margin-left: var( --size-padLarge );\n  align-items: center;\n  padding-left: var( --size-padLarge );\n  margin-right: var( --size-padXLarge );\n  border-radius: 12px;\n  padding-right: var( --size-padLarge );\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.toggleButton.toggleButton-nav[data-value=true] {\n  color: var( --color-white );\n  background-color: var( --color-brand500 );\n}\n.toggleButton.toggleButton-nav:hover {\n  background-color: rgba(38, 26, 203, 0.5);\n}\n.toggleButton.toggleButton-nav.toggleButton-navSubItem[data-value=true] {\n  border-radius: 100px;\n}\n.toggleButton.toggleButton-nav.toggleButton-navCollapsed {\n  width: 40px;\n  height: 40px;\n  padding: 0px;\n  display: flex;\n  margin-left: auto;\n  align-items: center;\n  margin-right: auto;\n  flex-direction: row;\n  justify-content: center;\n}\n.toggleButton.toggleButton-nav.toggleButton-navSecondary {\n  font: bold 15px/24px var( --vf-Inter );\n  color: var( --color-base500 );\n  min-height: 0px;\n  border-radius: 100px;\n}\n.toggleButton.toggleButton-nav.toggleButton-navSecondary[data-value=true] {\n  color: var( --color-brand500 );\n  background-color: var( --color-brand100 );\n}\n.toggleButton.toggleButton-nav.toggleButton-navSecondary:hover {\n  color: var( --color-brand500 );\n  background-color: var( --color-brand050 );\n}\n.toggleButton.toggleButton-mobile {\n  border-radius: 100%;\n}\n.toggleButton.toggleButton-mobile[data-value=true] {\n  color: var( --color-white );\n  background-color: var( --color-brand500 );\n}\n.toggleButton.toggleButton-mobileDateRange {\n  color: var( --color-base500 );\n  width: 100%;\n  height: 40px;\n  text-align: center;\n  border-radius: 100%;\n  background-color: var( --color-base100 );\n}\n.toggleButton.toggleButton-mobileDateRange[data-value=true] {\n  color: var( --color-brand500 );\n  background-color: var( --color-brand100 );\n}\n.toggleButton.toggleButton-mobileDateRange:active {\n  color: var( --color-brand500 );\n  background-color: var( --color-brand050 );\n}\n.toggleButton.toggleButton-mobileDateRange:active[data-value=true] {\n  background-color: var( --color-brand100 );\n}\n.toggleButton.toggleButton-nav > *+* {\n  margin: 0 0 0 var( --size-padLarge );\n}\n.toggleButton.toggleButton-actions > *+* {\n  margin: 0 var( --size-padSmall ) 0 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleButton": `toggleButton_xmE5L`,
	"toggleButton-iconBig": `toggleButton-iconBig_fytRJ`,
	"toggleButton-iconMedium": `toggleButton-iconMedium_hsFcg`,
	"toggleButton-iconSmall": `toggleButton-iconSmall_fPjTE`,
	"toggleButton-actions": `toggleButton-actions_sO2d8`,
	"toggleButton-nav": `toggleButton-nav_NuPbq`,
	"toggleButton-navSubItem": `toggleButton-navSubItem_eOZym`,
	"toggleButton-navCollapsed": `toggleButton-navCollapsed_mPKIc`,
	"toggleButton-navSecondary": `toggleButton-navSecondary_RCyln`,
	"toggleButton-mobile": `toggleButton-mobile_LwOqO`,
	"toggleButton-mobileDateRange": `toggleButton-mobileDateRange_Celzo`
};
export default ___CSS_LOADER_EXPORT___;
